import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-14a2fb8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-info" }
const _hoisted_2 = { class: "software-name" }

import { computed, ref } from 'vue'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { softDisableTopList } from '../software-disabled.service'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'software-interception-ranking-chart',
  props: {
    data: { default: () => [] }
  },
  emits: ["timeRangeChange", "itemClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const { t } = useI18n()

const emit = __emit

const loading = ref(false)
const timeRange = ref<TimeRange>(TimeRange.DAYS_30)

const rankingData = computed(() => {
  return props.data.map(item => ({
    name: item.name?.trim() ? item.name : t('commonPage.unknown'),
    rawName: (item.name || '').trim(),
    count: item.count || 0,
  }))
})

function handleTimeRangeChange(value: TimeRange) {
  timeRange.value = value
  emit('timeRangeChange', value)
}

function onRankingItemClick (item: { rawName?: string }) {
  emit('itemClick', {
    rawName: (item.rawName ?? '').trim(),
  })
}

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('softwareDisabledCharts.interceptionRankingTitle'),
    data: rankingData.value,
    "time-range": timeRange.value,
    "show-time-range": true,
    loading: loading.value,
    "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
    unit: _ctx.$t('usbPolicy.unitTimes'),
    "name-key": "name",
    "row-clickable": "",
    "onUpdate:timeRange": handleTimeRangeChange,
    onItemClick: onRankingItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    "item-name": _withCtx(({ item }: any) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.name), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "data", "time-range", "loading", "unit"]))
}
}

})